"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isVideoProps = (props) => "videoUrl" in props;
exports.default = isVideoProps;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbWVkaWEvdXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQSxNQUFNLFlBQVksR0FBRyxDQUFDLEtBQVksRUFBdUIsRUFBRSxDQUFDLFVBQVUsSUFBSSxLQUFLLENBQUM7QUFFaEYsa0JBQWUsWUFBWSxDQUFDIn0=